<template>
  <div class="introduction-page">
    <!-- 顶部背景横幅 -->
    <div class="page-banner"></div>

    <!-- 主体内容区 -->
    <div class="page-content">
      <!-- 面包屑 -->
      <div class="breadcrumb">
        <span class="breadcrumb-icon">🏠</span>
        <span class="breadcrumb-text">当前位置：<span class="breadcrumb-link" @click="goHome">首页</span> / {{ parentNavName }}</span>
      </div>

      <div class="content-wrapper">
        <!-- 左侧菜单 -->
        <div class="sidebar">
          <div class="sidebar-title">{{ parentNavName }}</div>
          <ul class="sidebar-menu">
            <li 
              v-for="item in menuItems" 
              :key="item.id"
              class="menu-item" 
              :class="{ active: activeTab === item.id}"
              @click="handleMenuClick(item)"
            >
              <span>{{ item.name }}</span>
              <span class="arrow">›</span>
            </li>
          </ul>
        </div>

        <!-- 右侧内容 -->
        <div class="main-content">
          <TextListPage :listData="listData" ident="work" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import sys from '@/api/index'
import TextListPage from './textListPage.vue'

const router = useRouter()
const route = useRoute()

const activeTab = ref('')
const menuItems = ref([])
const parentNavName = ref('党群工作')
const listData = ref([])

// 跳转到首页
const goHome = () => {
  router.push('/')
}

// 获取导航数据
const getNavMainList = async () => {
  try {
    const res = await sys.getList({ ident: 'work' })
    if (res && res.code === 2000 && res.data && Array.isArray(res.data)) {
      // 直接使用返回的数据生成菜单
      if (res.data.length > 0) {
        parentNavName.value = '党群工作'
        
        // 将返回的数据映射为菜单项，保留 ident 字段
        menuItems.value = res.data.map(item => ({
          name: item.name,
          id: item.id,
          ident: item.ident
        }))
        
        // 检查路由中是否存在 cid 参数
        const cidFromRoute = route.query.cid
        let selectedItem = null
        
        if (cidFromRoute) {
          // 查找与 cid 匹配的菜单项
          selectedItem = menuItems.value.find(item => item.id == cidFromRoute)
        }
        
        // 如果找到匹配的菜单项，选中它；否则选中第一项
        if (selectedItem) {
          activeTab.value = selectedItem.id
          handleMenuClick(selectedItem)
        } else if (menuItems.value.length > 0) {
          activeTab.value = menuItems.value[0].id
          handleMenuClick(menuItems.value[0])
        }
      }
    }
  } catch (error) {
    console.error('获取导航数据失败:', error)
    // 使用默认菜单
    menuItems.value = [
      { name: '党群活动', id: 'activity', ident: 'activity' }
    ]
  }
}

// 处理菜单点击事件
const handleMenuClick = async (item) => {
  activeTab.value = item.id
  
  // 调用 getTopList 接口，传入当前项的 id
  try {
    const res = await sys.getTopList({cid:item.id})
    if (res && res.code === 2000) {
      console.log('获取详情数据成功:', res.data)
      
      // 直接显示列表数据
      const dataList = res.data?.data || []
      listData.value = dataList
    } else {
      // 接口返回失败，清空列表
      listData.value = []
    }
  } catch (error) {
    console.error('获取详情数据失败:', error)
    // 发生错误时，清空列表
    listData.value = []
  }
}

onMounted(() => {
  getNavMainList()
})
</script>

<style scoped>
.introduction-page {
  width: 100%;
  min-height: 100vh;
}

/* 顶部横幅 */
.page-banner {
  width: 100%;
  height: 210px;
  background: url('~@/assets/images/innerbanner.jpg') center center / cover no-repeat;
  position: relative;
}

/* 主体内容 */
.page-content {
  max-width: 1400px;
  margin: -83px auto 0;
  padding: 0px 20px 60px;
  position: relative;
}

/* 面包屑 */
.breadcrumb {
    height: 80px;
  display: flex;
  align-items: center;
  font-size: 14px;
  background-color: #eaf7fa;
  padding: 10px 20px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  
}

.breadcrumb-icon {
  margin-right: 8px;
  font-size: 16px;
  color: #4facfe;
}

.breadcrumb-text {
  color: #666;
  font-size: 1rem;
}

.breadcrumb-link {
  color: #666;
  cursor: pointer;
  transition: color 0.3s ease;
}

.breadcrumb-link:hover {
  color: #4facfe;
}

.content-wrapper {
  display: flex;
}

/* 左侧菜单 */
.sidebar {
  width: 240px;
  flex-shrink: 0;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  height: fit-content;
}

.sidebar-title {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  padding: 20px 24px;
  text-align: left;
  border-radius: 8px 8px 0 0;
}

.sidebar-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  color: #333;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fff;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item:hover {
  background-color: #f8f9fa;
  color: #4facfe;
}

.menu-item.active {
  background-color: #f0f8ff;
  color: #4facfe;
  font-weight: 500;
}

.menu-item .arrow {
  font-size: 18px;
  color: #999;
}

.menu-item.active .arrow,
.menu-item:hover .arrow {
  color: #4facfe;
}

/* 右侧内容 */
.main-content {
  flex: 1;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.content-title {
  font-size: 26px;
  color: #333;
  margin-bottom: 30px;
  font-weight: 500;
  text-align: center;
  position: relative;
  padding-bottom: 15px;
}

.content-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: linear-gradient(to right, #4facfe, #00f2fe);
  border-radius: 2px;
}

.content-text {
  color: #666;
  line-height: 2;
  font-size: 15px;
}

.content-text p {
  margin-bottom: 20px;
  text-align: justify;
  text-indent: 2em;
}

.content-text p:last-child {
  margin-bottom: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .content-wrapper {
    flex-direction: column;
  }
  
  .sidebar {
    width: 100%;
  }
  
  .main-content {
    padding: 30px 20px;
  }
  
  .content-title {
    font-size: 22px;
  }
  
  .content-text {
    font-size: 14px;
  }
  
  .page-banner {
    height: 120px;
  }
}
</style>